import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../../web/ReactQueryProvider';
import { timeEntryKeys } from './keys';
import { ITimeEntryPage, ITimeEntryReview } from './types';

export function useTimeEntryReviewQueueQuery({ enabled = true }: { enabled?: boolean } = {}) {
	const userSession = useUserSession();
	return useQuery({
		queryKey: timeEntryKeys.reviewQueue(),
		queryFn: () =>
			userSession.webServiceHelper.callAsync<ITimeEntryPage<ITimeEntryReview>>('TimeEntry/reviewQueue', 'GET'),
		enabled,
		staleTime: 60_000,
		meta: {
			errorLogging: { action: 'useTimeEntryReviewQueueQuery', category: 'TimeEntry' },
		} satisfies LevStandardQueryMeta,
	});
}
